import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmountDamage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 82,
	height: 72,
	viewBox: "0 0 82 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 35.8624,
			cy: 33.1153,
			rx: 30.0889,
			ry: 30.4044,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.3063 32.5233C59.3063 48.7883 46.1941 61.9666 30.0281 61.9666C13.8621 61.9666 0.75 48.7883 0.75 32.5233C0.75 16.2584 13.8621 3.08008 30.0281 3.08008C46.1941 3.08008 59.3063 16.2584 59.3063 32.5233Z",
			stroke: "#7548F0",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 61.9402,
			cy: 17.5757,
			rx: 2.67457,
			ry: 2.70261,
			fill: "#F6F5FF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 57.2598,
			cy: 2.03435,
			rx: 2.00593,
			ry: 2.02654,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 41.0006,
			cy: 69.1044,
			rx: 2.88732,
			ry: 2.9032,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 29.4511,
			cy: 70.265,
			rx: 1.73239,
			ry: 1.74156,
			fill: "#CAEDDA"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 79.9942,
			cy: 16.8996,
			rx: 2.00593,
			ry: 2.02654,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.8163 30.3471H42.8738H52.9313M10.9688 39.4907L21.4916 28.3877C22.1778 27.6725 23.0199 27.1 23.9623 26.708C24.9047 26.316 25.9261 26.1133 26.9592 26.1133H27.3304M16.3586 48.1292H26.4161L33.7306 43.0486C33.7306 43.0486 35.2118 42.1222 37.3879 40.5083C41.9595 37.1212 37.3879 31.7595 32.8163 34.5809C29.0932 36.8791 25.5018 38.8148 25.5018 38.8148",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.3281 37.9692V26.9613C27.3281 26.063 27.7134 25.2015 28.3993 24.5663C29.0852 23.9311 30.0154 23.5742 30.9854 23.5742H49.2718C50.2417 23.5742 51.172 23.9311 51.8579 24.5663C52.5437 25.2015 52.929 26.063 52.929 26.9613V37.1225C52.929 38.0208 52.5437 38.8823 51.8579 39.5175C51.172 40.1527 50.2417 40.5095 49.2718 40.5095H37.3856",
			stroke: "#7548F0",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.828 58.0786L60.8122 53.0351L65.828 58.0786ZM60.8122 53.0351C61.6701 52.1724 62.3507 51.1482 62.8151 50.0211C63.2794 48.8939 63.5184 47.6858 63.5184 46.4658C63.5184 45.2457 63.2794 44.0376 62.8151 42.9105C62.3507 41.7833 61.6701 40.7591 60.8122 39.8964C59.9542 39.0337 58.9356 38.3494 57.8146 37.8825C56.6936 37.4156 55.4921 37.1753 54.2787 37.1753C53.0654 37.1753 51.8639 37.4156 50.7429 37.8825C49.6219 38.3494 48.6033 39.0337 47.7453 39.8964C46.0125 41.6387 45.0391 44.0018 45.0391 46.4658C45.0391 48.9298 46.0125 51.2928 47.7453 53.0351C49.4781 54.7774 51.8282 55.7562 54.2787 55.7562C56.7292 55.7562 59.0794 54.7774 60.8122 53.0351Z",
			fill: "#F8F7FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.828 58.0786L60.8122 53.0351M60.8122 53.0351C61.6701 52.1724 62.3507 51.1482 62.8151 50.0211C63.2794 48.8939 63.5184 47.6858 63.5184 46.4658C63.5184 45.2457 63.2794 44.0376 62.8151 42.9105C62.3507 41.7833 61.6701 40.7591 60.8122 39.8964C59.9542 39.0337 58.9356 38.3494 57.8146 37.8825C56.6936 37.4156 55.4921 37.1753 54.2787 37.1753C53.0654 37.1753 51.8639 37.4156 50.7429 37.8825C49.6219 38.3494 48.6033 39.0337 47.7453 39.8964C46.0125 41.6387 45.0391 44.0018 45.0391 46.4658C45.0391 48.9298 46.0125 51.2928 47.7453 53.0351C49.4781 54.7774 51.8282 55.7562 54.2787 55.7562C56.7292 55.7562 59.0794 54.7774 60.8122 53.0351Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.2066 46.4875C61.2023 47.866 60.7914 49.2123 60.026 50.3559C59.2605 51.4996 58.1749 52.3893 56.9065 52.9123C55.638 53.4354 54.2437 53.5684 52.9001 53.2944C51.5565 53.0205 50.3239 52.3519 49.3582 51.3734C48.3926 50.3948 47.7373 49.1502 47.4753 47.7971C47.2134 46.444 47.3565 45.0431 47.8865 43.7718C48.4166 42.5005 49.3098 41.4158 50.4531 40.6551C51.5964 39.8943 52.9385 39.4917 54.3094 39.4981C55.2199 39.4976 56.1214 39.6783 56.962 40.0301C57.8026 40.3818 58.5655 40.8974 59.2068 41.5473C59.8481 42.1971 60.355 42.9683 60.6982 43.8162C61.0414 44.6641 61.2142 45.572 61.2066 46.4875ZM60.068 46.4794C60.0694 45.3281 59.7314 44.2022 59.0968 43.244C58.4623 42.2857 57.5596 41.5379 56.5027 41.0951C55.4458 40.6524 54.2821 40.5344 53.1586 40.7561C52.0351 40.9778 51.0021 41.5293 50.1901 42.3409C49.378 43.1525 48.8233 44.1879 48.5961 45.3162C48.3688 46.4446 48.4791 47.6154 48.9131 48.6807C49.347 49.7461 50.0852 50.6582 51.0344 51.3021C51.9836 51.9459 53.1012 52.2925 54.2461 52.2981C55.0108 52.3096 55.7701 52.1671 56.4793 51.8792C57.1885 51.5912 57.8332 51.1636 58.3757 50.6215C58.9181 50.0793 59.3473 49.4336 59.6379 48.7223C59.9285 48.0109 60.0748 47.2484 60.068 46.4794Z",
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.4322 42.3702C55.4322 42.6999 55.1398 42.9258 54.641 42.9364C53.9423 42.9552 53.2612 43.1313 52.6637 43.4474C52.4079 43.5867 52.1681 43.7473 51.9478 43.9269C51.5816 44.2093 51.235 44.2119 50.9698 43.9479C50.9106 43.8881 50.8665 43.8181 50.8403 43.7425C50.814 43.6669 50.8063 43.5874 50.8175 43.5091C50.8287 43.4307 50.8586 43.3553 50.9054 43.2876C50.9521 43.22 51.0146 43.1616 51.0888 43.1163C52.0606 42.2983 53.3549 41.8358 54.7058 41.8237C54.7953 41.8152 54.8858 41.8228 54.9718 41.8461C55.0577 41.8694 55.1373 41.9079 55.2054 41.9591C55.2736 42.0104 55.3289 42.0733 55.3679 42.1441C55.4069 42.2148 55.4288 42.2918 55.4322 42.3702Z",
			fill: "#0DC277"
		})
	]
});
export default SvgAmountDamage;
